import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class VideosService {
  private _videoOpen = new BehaviorSubject<string>("");
  public videoOpenCurrent = this._videoOpen.asObservable();

  constructor() {}

  public openVideo(video: string): void {
    this._videoOpen.next(video);
  }

  public closeVideo(): void {
    this._videoOpen.next("");
  }
}
